import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { ConversionTableResource } from '@ab/ams-school-api/types/private/v1';

export type DeleteConversionTablePayload = {
  conversionTable: ConversionTableResource;
};

export function useDeleteConversionTable() {
  const request = useRequest();
  const queryClient = useQueryClient();

  const { isLoading, error, mutateAsync } = useMutation(
    ['deleteConversionTable'],
    async (payload: DeleteConversionTablePayload) => {
      const { conversionTable } = payload;
      await request<void>(`${config.apiHost}/private/v1/conversion_tables/${conversionTable.id}`, {
        method: 'DELETE',
        isExpectedResponse: (_res: unknown): _res is void => true,
      });

      // Invalidate queries to refresh the conversion tables list
      queryClient.invalidateQueries({ queryKey: ['conversionTables'] });
    }
  );

  return {
    deleteConversionTable: mutateAsync,
    isDeleting: isLoading,
    error,
  };
}
